"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.braintreeOnPaymentAuthorizedApple = void 0;
const src_1 = require("../..");
const types_1 = require("../../types");
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
function braintreeOnPaymentAuthorizedApple(event) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return __awaiter(this, void 0, void 0, function* () {
        const appleInstance = (0, src_1.getBraintreeApplePayInstanceChecked)();
        const applePaySession = (0, src_1.getBraintreeApplePaySessionChecked)();
        const { token, shippingContact, billingContact } = event.payment;
        const { givenName, familyName, emailAddress } = shippingContact !== null && shippingContact !== void 0 ? shippingContact : {};
        const shippingAddress = (0, src_1.formatBraintreeShippingAddressApple)(shippingContact);
        const billingAddress = (0, src_1.formatBraintreeShippingAddressApple)(billingContact);
        const isSameAddress = (0, src_1.isObjectEquals)(shippingAddress, billingAddress);
        const fail = (error) => {
            applePaySession.completePayment({
                status: ApplePaySession.STATUS_FAILURE,
                errors: [error]
            });
        };
        const customerResult = yield (0, src_1.callGuestCustomerEndpoint)(givenName !== null && givenName !== void 0 ? givenName : '', familyName !== null && familyName !== void 0 ? familyName : '', emailAddress !== null && emailAddress !== void 0 ? emailAddress : '');
        if (!customerResult.success) {
            return fail({
                code: src_1.braintreeConstants.APPLEPAY_ERROR_CODE_SHIPPING_CONTACT,
                message: (_b = (_a = customerResult.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : 'There was an unknown error while validating your customer information.'
            });
        }
        const shippingAddressResponse = yield (0, src_1.callShippingAddressEndpoint)(shippingAddress, false);
        if (!shippingAddressResponse.success) {
            return fail({
                code: src_1.braintreeConstants.APPLEPAY_ERROR_CODE_SHIPPING_CONTACT,
                message: (_d = (_c = shippingAddressResponse.error) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : 'There was an unknown error while validating your shipping address.'
            });
        }
        const billingAddressResponse = yield (0, src_1.callBillingAddressEndpoint)(billingAddress, !isSameAddress);
        if (!billingAddressResponse.success) {
            return fail({
                code: src_1.braintreeConstants.APPLEPAY_ERROR_CODE_BILLING_CONTACT,
                message: (_f = (_e = billingAddressResponse.error) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : 'There was an unknown error while validating your billing address.'
            });
        }
        const taxResponse = yield (0, checkout_frontend_library_1.setTaxes)(types_1.API_RETRY);
        if (!taxResponse.success) {
            return fail({
                code: src_1.braintreeConstants.APPLEPAY_ERROR_CODE_UNKNOWN,
                message: (_h = (_g = taxResponse.error) === null || _g === void 0 ? void 0 : _g.message) !== null && _h !== void 0 ? _h : 'There was an unknown error while calculating the taxes.'
            });
        }
        try {
            const payload = yield appleInstance.tokenize({ token });
            const { nonce } = payload;
            const { public_id: gatewayPublicId } = (0, src_1.getBraintreeAppleCredentialsChecked)();
            const { iso_code: currencyCode } = (0, checkout_frontend_library_1.getCurrency)();
            const { order_total } = (0, checkout_frontend_library_1.getApplicationState)();
            const payment = {
                token: nonce,
                gateway_public_id: gatewayPublicId,
                currency: currencyCode,
                amount: order_total
            };
            const paymentResult = yield (0, checkout_frontend_library_1.addPayment)(payment, types_1.API_RETRY);
            if (!paymentResult.success) {
                return fail({
                    code: src_1.braintreeConstants.APPLEPAY_ERROR_CODE_UNKNOWN,
                    message: (_k = (_j = paymentResult.error) === null || _j === void 0 ? void 0 : _j.message) !== null && _k !== void 0 ? _k : 'There was an unknown error while processing your payment.'
                });
            }
            applePaySession.completePayment(ApplePaySession.STATUS_SUCCESS);
            (0, src_1.orderProcessing)();
        }
        catch (e) {
            if (e instanceof Error) {
                return fail({
                    code: src_1.braintreeConstants.APPLEPAY_ERROR_CODE_UNKNOWN,
                    message: e.message
                });
            }
            return fail({
                code: src_1.braintreeConstants.APPLEPAY_ERROR_CODE_UNKNOWN,
                message: e ? `${e}` : 'There was an unknown error while processing your payment.'
            });
        }
    });
}
exports.braintreeOnPaymentAuthorizedApple = braintreeOnPaymentAuthorizedApple;
